import { PillBanner } from "components/footer/PillBanner";
import { PillBannerButton } from "components/footer/PillBannerButton";
import { PublicationStatus } from "components/server-types";
import { t } from "i18n/i18n";
import { Dialog } from "mds/components/Dialog";
import { IconText } from "mds/components/IconText";
import { ProgressBar } from "mds/components/ProgressBar";
import { CircleCheckFilledIcon, CircleExclamationFilledIcon } from "mds/icons";
import { useAppSelector } from "store/index";
import {
  selectCurrentSectionId,
  selectLatestPublicationForCurrentSection,
  selectLinkedSectionCountForCurrentSection,
} from "store/selectors";
import { Link } from "utils/routing";
import { sectionPublishingUrl } from "utils/urls";

export const PublishBanner = () => {
  const sectionId = useAppSelector(selectCurrentSectionId);
  const linkedSectionCount = useAppSelector(selectLinkedSectionCountForCurrentSection);
  const latestPublication = useAppSelector(selectLatestPublicationForCurrentSection);

  if (!sectionId || !latestPublication || linkedSectionCount === 0) {
    return null;
  }

  const isDraft = latestPublication.status === PublicationStatus.DRAFT;
  const isCompleted = latestPublication.status === PublicationStatus.COMPLETED;
  const isStarted = latestPublication.status === PublicationStatus.STARTED;

  return (
    <>
      {(isDraft || isCompleted) && (
        <PillBanner
          buttonChildren={
            isDraft && (
              <PillBannerButton
                as={Link}
                eventName="Publish template section"
                kind="banner-hibiscus"
                to={sectionPublishingUrl(sectionId)}
              >
                {t("publishing.review_changes")}
              </PillBannerButton>
            )
          }
          kind={isDraft ? "hibiscus" : "moss"}
          label="Publish banner"
          textChildren={
            isDraft ? (
              <IconText
                iconStart={<CircleExclamationFilledIcon className="text-hibiscus-tint-20" />}
                text={t("publishing.linked_sections_out_of_date")}
                truncateText
              />
            ) : (
              <IconText
                iconStart={<CircleCheckFilledIcon className="text-moss-tint-30" />}
                text={t("publishing.linked_sections_up_to_date")}
                truncateText
              />
            )
          }
        />
      )}

      <Dialog
        dismissible={false}
        open={isStarted}
        title={t("publishing.publish_in_progress_title")}
        onClose={() => {}}
      >
        <div className="mt-4 flex items-center gap-3">
          <ProgressBar
            count={latestPublication.completed_replication_count}
            total={latestPublication.linked_sections_count}
          />
        </div>
        <p className="mt-4">
          {t("publishing.publish_in_progress_details", {
            count: latestPublication.linked_sections_count,
          })}
        </p>
      </Dialog>
    </>
  );
};
